import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"

import { useAppSelector } from "@/App"
import { ConfirmModal } from "@/components/ConfirmModal"
import { selectDriverById, updateDriver } from "@/store/drivers"
import { Driver } from "@/types"
import { fetchDeleteBreakById } from "@/utils"
import { handleStandardError } from "@/utils/errors"

type DriversFinalBreakDeleteModalProps = {
  driverId: Driver["id"]
  handleClose: () => void
}

export const DriversFinalBreakDeleteModal = ({ driverId, handleClose }: DriversFinalBreakDeleteModalProps) => {
  const driver = useAppSelector(selectDriverById(driverId))

  const [isSubmitting, setIsSubmitting] = useState(false)

  const { t } = useTranslation()
  const dispatch = useDispatch()

  if (!driver) return null

  async function handleSubmit() {
    if (!driver || !driver.today_temporary_break) return null
    setIsSubmitting(true)

    try {
      const { response, json } = await fetchDeleteBreakById(driverId, driver.today_temporary_break.id)
      const updatedDriver = json?.data

      if (response.ok && updatedDriver) {
        toast.success(t("drivers:end_of_shift_success"))
        dispatch(updateDriver(updatedDriver))
        handleClose()
      } else {
        handleStandardError(response, json)
      }
    } catch (error) {
      toast.error(t("drivers:end_of_shift_fail"))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <ConfirmModal
      isLoading={isSubmitting}
      handleClose={handleClose}
      handleConfirm={handleSubmit}
      title={`${t("drivers:courier")}: ${driver.name}`}
      description={t("drivers:delete_end_of_shift")}
      autoFocusConfirm
    />
  )
}
